/* eslint-disable */
import { truncateText } from '@utils/formatter';
import React, { useEffect, useState } from 'react';
import { WHEEL_COLORS } from './util';
import { useAppLayout } from '@context/LayoutContext';

interface WheelComponentProps {
  segments: string[];
  segColors?: string[];
  winningSegment: string;
  onFinished?: (value: string) => void;
  onRotate?: () => void;
  onRotatefinish?: () => void;
  // onClickSpin: () => void;
  primaryColor?: string;
  primaryColoraround?: string;
  contrastColor?: string;
  buttonText?: string;
  isOnlyOnce?: boolean;
  size?: number;
  upDuration?: number;
  downDuration?: number;
  fontFamily?: string;
  width?: string;
  height?: string;
  isRunning?: boolean;
}

const WheelComponent = (props: WheelComponentProps) => {
  const { isMobile } = useAppLayout();
  let {
    segments = [],
    segColors = WHEEL_COLORS,
    winningSegment = '',
    onFinished,
    // onClickSpin,
    isRunning,
    primaryColor = '#f57747',
    primaryColoraround = 'white',
    contrastColor = 'white',
    buttonText = '',
    isOnlyOnce = true,
    size = 290,
    upDuration = 800,
    downDuration = 1000,
    fontFamily = 'proxima-nova',
    width = '100',
    height = '100',
  } = props;

  let currentSegment = '';
  let isStarted = false;
  const [isFinished, setFinished] = useState(false);
  let timerHandle = 0;
  const timerDelay = segments.length;
  let angleCurrent = 0;
  let angleDelta = 0;
  let canvasContext: CanvasRenderingContext2D;
  let maxSpeed = Math.PI / segments.length ;
  const upTime = segments.length * upDuration;
  const downTime = segments.length * downDuration;
  let spinStart = 0;
  let frames = 0;

  const sizeSpin = size * 2 + 20;

  const centerX = sizeSpin / 2;
  const centerY = sizeSpin / 2;

  useEffect(() => {
    wheelInit();
    setTimeout(() => {
      window.scrollTo(0, 1);
    }, 0);
  }, []);

  useEffect(() => {
    if (isRunning && !isStarted) {
      spin();
    }
  }, [isRunning]);

  const wheelInit = () => {
    initCanvas();
    wheelDraw();
  };

  const initCanvas = () => {
    let canvas = document.getElementById('canvas') as HTMLCanvasElement;
    if (navigator.appVersion.indexOf('MSIE') !== -1) {
      canvas = document.createElement('canvas');
      canvas.setAttribute('width', width);
      canvas.setAttribute('height', height);
      canvas.setAttribute('id', 'canvas');
      document.getElementById('wheel')?.appendChild(canvas);
    }
    canvasContext = canvas.getContext('2d') as CanvasRenderingContext2D;
  };

  const spin = () => {
    isStarted = true;
    // onRotate();

    if (timerHandle === 0) {
      spinStart = new Date().getTime();
      maxSpeed = (Math.PI / (segments.length > 10 ? (segments.length / 3) : segments.length ));
      frames = 0;
      timerHandle = window.setInterval(onTimerTick,timerDelay);
    }
  };
  const onTimerTick = () => {
    frames++;

    draw();
    const duration = new Date().getTime() - spinStart;
    let progress = 0;
    let finished = false;

    //Bắt đầu vòng quay, tốc độ vòng quay tăng lên dần
    if (duration < upTime) {
      progress = duration / upTime;
      angleDelta = maxSpeed * Math.sin(progress * Math.PI / 2);
    } else {
      if (winningSegment) {
        if (currentSegment === winningSegment && frames > segments.length) {
          progress = duration / upTime;
          angleDelta = maxSpeed * Math.sin(progress * Math.PI / 2 + Math.PI / 2);
          if(progress > 1){
            progress = 1;
          }
        } else {
          progress = duration / downTime;
          angleDelta = maxSpeed * Math.sin(progress * Math.PI / 2 + Math.PI / 2);
        }
      } else {
        progress = duration / downTime;
        if (progress >= 0.8) {
          angleDelta = (maxSpeed / 1.2) * Math.sin((progress * Math.PI) / 2 + Math.PI / 2);
        } else if (progress >= 0.98) {
          angleDelta = (maxSpeed / 2) * Math.sin((progress * Math.PI) / 2 + Math.PI / 2);
        } else angleDelta = maxSpeed * Math.sin((progress * Math.PI) / 2 + Math.PI / 2);
      }
      if (progress >= 1){
        finished = true;
      }
    }

    angleCurrent += angleDelta;
    while (angleCurrent >= Math.PI * 2){
      angleCurrent -= Math.PI * 2
    };
   
    if (finished) {
      setFinished(true);
      onFinished?.(currentSegment);

      clearInterval(timerHandle);
      timerHandle = 0;
      angleDelta = 0;


      // Sau khi vòng quay kết thúc => tính toán lại góc của giải trúng thưởng 
      // => điều chỉnh lại kim quay nằm giữa 2 cạnh của giải trúng thưởng
      const len = segments.length;
      const PI2 = Math.PI * 2;
      const indexOfWinner = getReverseIndexOfWinner();
      let angleFrom = PI2 * (indexOfWinner  / len); 
      let angleTo = PI2 * ((indexOfWinner + 1) / len); 
      angleCurrent = getRandomAngleInRange(angleFrom,angleTo);
      draw();
    }
  };

  // Lấy vị trí đảo ngược của giải trúng thưởng trong mảng 
  // Vì danh sách giải thưởng sắp sếp theo chiều kim đồng hồ, còn khi tính góc thì theo hướng ngược lại
  // => Đảo ngược thì mới lấy ra đúng vị trí và tính đúng góc của giải trúng thưởng
  const getReverseIndexOfWinner = () => {
    const reverseSegment = [...segments].reverse();
    return reverseSegment.indexOf(winningSegment);
  }

  // Chia giải trúng thưởng thành 6 phần
  // Bỏ ra 2 phần sát cạnh
  // Random trong 4 phần còn lại
  const  getRandomAngleInRange = (min:number, max:number) => {
    const range = max - min;
    const rangeRandom = range / 6;
    return getRandomFloat(min + rangeRandom, max - rangeRandom, 4);
  }

  const  getRandomFloat = (min:number, max:number, decimals:number) => {
    const str = (Math.random() * (max - min) + min).toFixed(decimals);
    return parseFloat(str);
  }

  const wheelDraw = () => {
    clear();
    drawWheel();
    drawNeedle();
  };

  const draw = () => {
    clear();
    drawWheel();
    drawNeedle();
  };

  const getFontSize = (key: number) => {
    if (!isMobile) {
      return key === 0 ? ' 22px ' : ' 16px ';
    }
    return key === 0 ? ' 14px ' : ' 12px ';
  };

  const drawSegment = (key: number, lastAngle: number, angle: number) => {
    const ctx = canvasContext;
    const value = segments[key];
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.arc(centerX, centerY, size, lastAngle, angle, false);
    ctx.lineTo(centerX, centerY);
    ctx.closePath();
    ctx.fillStyle = segColors[key];
    ctx.fill();
    ctx.stroke();
    ctx.save();
    ctx.translate(centerX, centerY);
    ctx.rotate((lastAngle + angle) / 2);
    ctx.fillStyle = key === 0 ? 'red' : contrastColor || 'white';
    ctx.font = getFontSize(key) + fontFamily;
    ctx.fillText(truncateText(value, 28), size / 2 + 7, 0);
    ctx.restore();
  };

  const drawWheel = () => {
    const ctx = canvasContext;
    let lastAngle = angleCurrent;
    const len = segments.length;
    const PI2 = Math.PI * 2;
    ctx.lineWidth = 1;
    ctx.strokeStyle = primaryColor || 'black';
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    ctx.font = '1em ' + fontFamily;
    for (let i = 1; i <= len; i++) {
      // giá trị của 1 góc ( 1 giải thưởng) =  angle - lastAngle
      const angle = PI2 * (i / len) + angleCurrent; 
      drawSegment(i - 1, lastAngle, angle);
      lastAngle = angle;
    }

    // Draw a center circle
    ctx.beginPath();
    ctx.arc(centerX, centerY, 30, 0, PI2, false);
    ctx.closePath();
    ctx.fillStyle = primaryColor || 'black';
    ctx.lineWidth = 3;
    ctx.strokeStyle = contrastColor || 'white';
    ctx.fill();
    ctx.font = 'bold 2em ' + fontFamily;
    ctx.fillStyle = contrastColor || 'white';
    ctx.textAlign = 'center';
    ctx.fillText(buttonText || '', centerX, centerY + 2);
    ctx.stroke();

    // Draw outer circle
    ctx.beginPath();
    ctx.arc(centerX, centerY, size, 0, PI2, false);
    ctx.closePath();
    ctx.lineWidth = 10;
    ctx.strokeStyle = primaryColoraround || 'white';
    ctx.stroke();
  };

  const drawNeedle = () => {
    const ctx = canvasContext;
    ctx.lineWidth = 1;
    ctx.strokeStyle = contrastColor || 'white';
    ctx.fillStyle = contrastColor || 'white';
    ctx.beginPath();
    // Thay đổi hướng mũi tên từ góc 0 độ -> góc 90 độ. 
    // => Để vị trí của mũi tên = cạnh đầu tiên của giải đầu tiên 
    // ( góc của giải đầu tiên = 0 => có thể tính ra góc của giải trúng thưởng)
    ctx.moveTo(centerX + 70, centerY );
    ctx.lineTo(centerX + 28.5 , centerY + 13.5);
    ctx.lineTo(centerX + 28.5, centerY - 13.5);
    ctx.closePath();
    ctx.fill();
    const change = angleCurrent + Math.PI / 2;
    let i = segments.length - Math.floor((change / (Math.PI * 2)) * segments.length) - 1;
    if (i < 0) i = i + segments.length;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = 'transparent';
    ctx.font = 'bold 1.5em ' + fontFamily;
    currentSegment = segments[i];
    isStarted && ctx.fillText(currentSegment, centerX + 10, centerY + size + 50);
  };
  const clear = () => {
    if (!canvasContext) {
      let canvas = document.getElementById('canvas') as HTMLCanvasElement;
      if (navigator.appVersion.indexOf('MSIE') !== -1) {
        canvas = document.createElement('canvas');
        canvas.setAttribute('width', width);
        canvas.setAttribute('height', height);
        canvas.setAttribute('id', 'canvas');
        document.getElementById('wheel')?.appendChild(canvas);
      }
      canvasContext = canvas.getContext('2d') as CanvasRenderingContext2D;
    }

    const ctx = canvasContext;
    ctx.clearRect(0, 0, sizeSpin, sizeSpin);
  };
  return (
    <div id="wheel">
      <canvas
        id="canvas"
        width={sizeSpin}
        height={sizeSpin}
        style={{
          pointerEvents: isFinished && isOnlyOnce ? 'none' : 'auto',
        }}
      />
    </div>
  );
};
export default WheelComponent;
